const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class DevelopmentOfWarfare extends Event {
    constructor(){
        super(
            Age.AgeA,
            EventNames.DevelopmentOfWarfare,
            "Each civilization with an unused worker may immediately build a Warrior unit for free.",
            {}
        )
    }
}

module.exports = DevelopmentOfWarfare;